<template>
  <table class="metrics-table">
    <tr>
      <th class="score-name-header">Score</th>
      <th class="metric-header">
        <NumeraiTooltip :text="meanTip">
          Mean
        </NumeraiTooltip>
      </th>
      <th class="metric-header">
        <NumeraiTooltip :text="stdTip">
          Standard Deviation
        </NumeraiTooltip>
      </th>
      <th class="metric-header">
        <NumeraiTooltip :text="sharpeTip">
          Sharpe
        </NumeraiTooltip>
      </th>
      <th class="metric-header">
        <NumeraiTooltip :text="maxDrawdownTip">
          Max Drawdown
        </NumeraiTooltip>
      </th>
    </tr>
    <tr>
      <td class="score-name-cell">
        <NumeraiTooltip :text="fncV4Tip">
          FNCv4
        </NumeraiTooltip>
      </td>
      <dtd :score="selectedUpload.validationFncV4Mean"> </dtd>
      <dtd :score="selectedUpload.validationFncV4Std"> </dtd>
      <dtd :score="selectedUpload.validationFncV4Sharpe"> </dtd>
      <dtd :score="selectedUpload.validationFncV4MaxDrawdown"> </dtd>
    </tr>
    <tr>
      <td class="score-name-cell">
        <NumeraiTooltip :text="ricTip">
          RIC
        </NumeraiTooltip>
      </td>
      <dtd :score="selectedUpload.validationRicMean"> </dtd>
      <dtd :score="selectedUpload.validationRicStd"> </dtd>
      <dtd :score="selectedUpload.validationRicSharpe"> </dtd>
      <dtd :score="selectedUpload.validationRicMaxDrawdown"> </dtd>
    </tr>
    <tr>
      <td class="score-name-cell">
        <NumeraiTooltip :text="corrV4Tip">
          CORRv4
        </NumeraiTooltip>
      </td>
      <dtd :score="selectedUpload.validationCorrV4Mean"> </dtd>
      <dtd :score="selectedUpload.validationCorrV4Std"> </dtd>
      <dtd :score="selectedUpload.validationCorrV4Sharpe"> </dtd>
      <dtd :score="selectedUpload.validationCorrV4MaxDrawdown"> </dtd>
    </tr>
    <tr>
      <td class="score-name-cell">
        <NumeraiTooltip :text="icV2Tip">
          ICv2
        </NumeraiTooltip>
      </td>
      <dtd :score="selectedUpload.validationIcV2Mean"> </dtd>
      <dtd :score="selectedUpload.validationIcV2Std"> </dtd>
      <dtd :score="selectedUpload.validationIcV2Sharpe"> </dtd>
      <dtd :score="selectedUpload.validationIcV2MaxDrawdown"> </dtd>
    </tr>
    <tr v-if="!tb200 && selectedUpload.validationChurnMean">
      <td class="score-name-cell">
        <NumeraiTooltip :text="churnTip">
          Churn
        </NumeraiTooltip>
      </td>
      <dtd :score="selectedUpload.validationChurnMean" :threshold="0.15"> </dtd>
      <dtd :score="selectedUpload.validationChurnStd"> </dtd>
      <dtd :score="null"> </dtd>
      <dtd :score="null"> </dtd>
    </tr>
  </table>
</template>

<script>
import DiagnosticsModalTableCell from './DiagnosticsModalTableCell'
import NumeraiTooltip from '@/components/shared/NumeraiTooltip'

export default {
  name: 'DiagnosticsModalTable',
  components: {
    dtd: DiagnosticsModalTableCell,
    NumeraiTooltip,
  },
  props: {
    uploads: {
      type: Array,
      required: false,
      default: null,
    },
    tb200: {
      type: Boolean,
      required: true,
      default: false,
    },
    uploadSelectedIndex: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      meanTip:
        'The mean of your per-era correlations between your ' +
        'predictions and the validation targets.',
      stdTip:
        'The standard deviation of per-era correlations between your ' +
        'predictions and the validation targets.',
      sharpeTip:
        'The mean of your per-era correlations divided by ' +
        'the standard deviation of your per-era correlations.',
      maxDrawdownTip:
        'The maximum difference from any local maxima to any subsequent' +
        ' minima for your cumulative sum of scores.',
      fncV4Tip:
        'Correlation with target_20d_factor_feat_neutral after ' +
        'neutralizing to all of the factors and features that the ' +
        'target is neutral to.',
      ricTip: 'Correlation with target_20d_factor_neutral.',
      corrTip:
        'Correlation with target_20d after neutralizing to all of ' +
        'the factors and features that the target is neutral to.',
      corrV4Tip: 'Correlation with target_20d_factor_feat_neutral.',
      icV2Tip: 'Correlation with target_20d_raw_return.',
      churnTip:
        '1 - Correlation of predictions at time t with predictions at time t-1.',
    }
  },
  computed: {
    selectedUpload() {
      if (!this.uploads) return null
      if (this.tb200) {
        if (this.uploads[this.uploadSelectedIndex]) {
          return this.uploads[this.uploadSelectedIndex].tb200Diagnostics
        } else {
          return null
        }
      }
      return this.uploads[this.uploadSelectedIndex]
    },
  },
}
</script>

<style>
.metrics-table {
  width: 100%;
  height: max-content;
  border-collapse: collapse;
  margin-bottom: 18px;
}

.score-name-header {
  text-align: left;
  color: var(--color-secondary);
  font-weight: 500;
  font-size: 1.2em;
}

.metric-header {
  text-align: right;
  color: var(--color-secondary);
  font-weight: 500;
  font-size: 1.2em;
}

.score-name-cell {
  color: var(--color-tertiary);
  font-size: 13px;
  font-weight: 500;
  width: 30%;
  border-bottom: 1px dotted var(--color-tertiary);
}
</style>
